import React from "react"

import Layout from "../components/Layout"
import SEO from "@/components/SEO"
import { StaticImage } from "gatsby-plugin-image"
import { routes } from "../utils/routes"

type PageProps = {
  data: any
}

const Legacies: React.FC<PageProps> = ({ data }) => (
  <Layout
    sectionOne={
      <>
        <div className="relative h-[67vh] md:min-h-[75vh]">
          <StaticImage
            src="../../static/images/_F7A5147.jpg"
            className="absolute inset-0 w-full h-full object-cover -z-50"
            alt="Legacies Header"
          />
          <div className="absolute inset-0 bg-[#131312]/50 -z-40"></div>

            <div className="container text-white h-[67vh] md:min-h-[75vh] flex items-center px-4">
              <div className="pl-2 md:pl-6 lg:pl-10 max-w-[1000px] translate-y-10 md:translate-y-16 lg:translate-y-20">
                <div className="pb-4">
                  <h1
                    className="text-left text-white text-[300%] sm:text-[400%] md:text-[531.25%] leading-[1] font-bold normal-case tracking-normal font-gilroy"
                  >
                    Legacies
                  </h1>
                  <div className="mt-5 h-[8px] sm:h-[10px] w-[200px] sm:w-[320px] bg-primary"></div>
                </div>
              </div>
            </div>
        </div>

        {/* Gold four-option bar below the fold */}
        <div className="bg-primary w-full h-[33vh] md:h-auto md:block">
          <div className="flex flex-col h-full w-full md:grid md:grid-cols-4 md:gap-0 md:items-stretch md:min-h-[84px]">
              <a href={routes.socialMobility()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Transformative Bursaries
              </a>
              <a href={routes.southWingDevelopment()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                The South Wing
              </a>
              <a href={routes.pledge()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Sponsor a Paviour
              </a>
              <a href={routes.donate()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] text-[19px] leading-[32.3px] md:px-2">
                Donate
              </a>
          </div>
        </div>
      </>
    }
  >
    <SEO title="Legacies" />
    <div className="container py-14">
      <div className="flex justify-center">
        <div className="flex flex-col gap-4 max-w-[700px]">
          <h3 className="mb-4 text-3xl font-gilroy font-bold normal-case">
            For more than two centuries, legacies and bequests have played a
            vital role in helping RBAI forge an <span className="text-primary">
              enviable reputation</span> for
              providing a <span className="text-primary">top quality educational experience
            </span>{" "} for boys from a wide
            range of backgrounds.
          </h3>

          <p className="font-gilroy">
            Legacy gifts from former pupils, staff and friends of RBAI have
            supported bursaries, prizes and the physical development of the
            School.
          </p>
          <p className="font-gilroy">
            To find out more about legacy giving and how you can remember RBAI
            in your will, please download our legacy brochure. If you would like
            to add RBAI to your existing will, please download the{" "}
            <a
              className="link underline hover:no-underline"
              href="/docs/Codicil Form.pdf"
              target="_blank"
            >
              Codicil form
            </a>
            .
          </p>
          <p className="font-gilroy">
            If you have any questions, or would like to discuss your plans in
            confidence, please contact Peter Anderson, RBAI Foundations
            Director.
          </p>
          <p className="font-gilroy">
            Telephone: ​028 9024 0461
            <br />
            Email: ​​
            <a
              className="link underline hover:no-underline"
              href="mailto:p.anderson@rbai.org.uk"
            >
              p.anderson@rbai.org.uk
            </a>
          </p>
        </div>
      </div>

      <div className="grid gap-8 md:grid-cols-3 pt-24">
        <a
          className="btn btn-secondary btn-lg font-gilroy font-medium capitalize"
          href="/docs/RBAI Legacy Leaflet.pdf"
          target="_blank"
        >
          Download Legacy Leaflet
        </a>

        <a
          className="btn btn-secondary btn-lg font-gilroy font-medium capitalize"
          href="/docs/Codicil Form.pdf"
          target="_blank"
        >
          Download Codicil Form
        </a>

        <button
          className="btn btn-secondary btn-lg font-gilroy font-medium capitalize"
          onClick={() => {
            window.open('/docs/Letting us know your intentions Oct 25.pdf', '_blank');
          }}
        >
          Letting us know your intentions form
        </button>
      </div>
    </div>
  </Layout>
)

export default Legacies
